import React from 'react';
import PropTypes from 'prop-types';
import './styles/style.scss';

const Center = props => <div className="c-vi-center">{props.children}</div>;

Center.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Center;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/visualIdentity/Center.jsx